import { all, call, put, takeLatest } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import { LoadersNames } from '../../ui/ui.constants';
import api from '../../../core/api';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { getInventoryRequirements } from './inventory.actions';

export function* getInventoryRequirementsSaga() {
  yield put(showLoader(LoadersNames.getInventoryRequirements));
  try {
    const result: any = yield call(api.inventory.getInventoryRequirements);
    yield put(getInventoryRequirements.done({ params: {}, result }));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  } finally {
    yield put(hideLoader(LoadersNames.getInventoryRequirements));
  }
}

// export function* getInventoryRequirementsReportSaga({ payload, meta }) {
//   yield put(showLoader(LoadersNames.getInventoryRequirements));
//   try {
//     const daysBack = differenceInDays(payload.to, payload.from);
//     const endDate = payload.to;
//
//     successHandler(meta);
//   } catch (err) {
//     yield put(notificationError(composeErrorMessage(err)));
//   } finally {
//     yield put(showLoader(LoadersNames.getInventoryRequirements));
//   }
// }

export function* watchInventorySaga() {
  yield all([yield takeLatest(getInventoryRequirements.started, getInventoryRequirementsSaga)]);
}
